export const logoutRequestB2B = {
    postLogoutRedirectUri: '',
};
